export default __webpack_public_path__ + "static/shyamal-jagannath-myee-talk-a97839ee323ec9fa0110adfe59add929.png";